import { CircularProgress, Tooltip } from '@material-ui/core'
import { HomeWorkOutlined } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'

export const HomePriceButtonOutlined = (props: {
  isManuallySet: boolean
  handleResetToDefaults: () => void
  isLoading: boolean
  translationKey?: string
}) => {
  const { t } = useTranslation()

  if (!props.isManuallySet) {
    return null
  }

  if (props.isLoading) {
    return <CircularProgress size={16} />
  }

  return (
    <Tooltip title={props.translationKey || t('project:reset-to-default')}>
      <HomeWorkOutlined
        className="reset-button"
        onClick={props.handleResetToDefaults}
      />
    </Tooltip>
  )
}
